import * as React from 'react'

import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import { LoadingScreen } from '@/components/common/loading-screen'

import { queryClient } from '@/libs/configs/tanstack-query'
import { createRouter } from '@/libs/configs/tanstack-router'
import { MediaQueryProvider } from '@/libs/hooks/use-media-query'
import { useUserPreference } from '@/libs/hooks/use-user-preference'

const router = createRouter()

export function App() {
	const { theme } = useUserPreference()

	React.useEffect(() => {
		document.body.classList.remove('light', 'dark')
		document.body.classList.add(theme)
	}, [theme])

	React.useEffect(() => {
		if (navigator.userAgent?.indexOf('iPhone') > -1) {
			document
				?.querySelector('[name=viewport]')
				?.setAttribute(
					'content',
					'width=device-width, initial-scale=1, maximum-scale=1'
				)
		}
	}, [])

	return (
		<React.Suspense fallback={<LoadingScreen />}>
			<QueryClientProvider client={queryClient}>
				<MediaQueryProvider query="(min-width: 768px)">
					<RouterProvider router={router} context={{ qc: queryClient }} />
				</MediaQueryProvider>
			</QueryClientProvider>
		</React.Suspense>
	)
}
